module.exports = __webpack_public_path__ + "static/media/Cypher.47b9967a.png";